import React, { useEffect, useState } from "react";
import AdminNavbar from "../../components/partial/AdminNavbar";
import FileUploader from "../../components/common/FileUploader";
import Button from "../../components/common/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  addGallery,
  getGalleryData,
  deleteGalleryData,
} from "../../store/gallery/reducer";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

// Modal Component
const GalleryModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  setTitle,
  description,
  setDescription,
  handleFilesUploaded,
}) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative bg-white w-full max-w-2xl p-6 rounded-lg shadow-xl">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-red-600 text-2xl font-bold"
        >
          &times;
        </button>
        <h3 className="text-2xl font-bold mb-4 text-center">Add New Gallery</h3>
        <input
          type="text"
          placeholder="Enter Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full mb-4 p-3 border rounded focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
        />
        <input
          type="text"
          placeholder="Enter Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full mb-4 p-3 border rounded focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
        />
        <FileUploader
          onFilesUploaded={handleFilesUploaded}
          allowMultiple={true}
        />
        <div className="mt-6 flex justify-end gap-4">
          <Button
            type="primary"
            className="px-6 py-2 bg-[#1e81b0] text-white font-semibold rounded hover:bg-[#1384ba]"
            onClick={onSubmit}
          >
            Submit
          </Button>
          <Button
            type="secondary"
            className="px-6 py-2 text-black font-semibold"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

// Main Gallery Component
const Gallery = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [openEdit, setOpenEdit] = useState(null);

  const dispatch = useDispatch();
  const rawGallery = useSelector((state) => state.galleryReducer.galleryData);
  const galleryData = (rawGallery && rawGallery.data) || [];
  console.log("[Gallery] rawGallery:", rawGallery);
  console.log("[Gallery] galleryData array:", galleryData);
  const navigate = useNavigate();

  const handleFilesUploaded = (files) => {
    setUploadedFiles([...files]);
  };
  const handleModalClose = () => {
    setModalOpen(false);
    setTitle("");
    setDescription("");
    setUploadedFiles([]);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);

    uploadedFiles.forEach((file) => {
      formData.append("photos", file);
    });

    dispatch(addGallery(formData)).then(() => {
      setModalOpen(false);
      dispatch(getGalleryData);
    });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this gallery?")) {
      dispatch(deleteGalleryData(id)).then(() => {
        dispatch(getGalleryData);
      });
    }
  };

  const handleEdit = (title, id) => {
    navigate(`/nvm-admin/gallery/edit/${encodeURIComponent(title)}`, {
      state: { id },
    });
  };

  useEffect(() => {
    dispatch(getGalleryData);
  }, [dispatch]);

  // Make sure galleryData exists before using it
  if (!galleryData) return <div>Loading...</div>;

  const noticesPerPage = 6;
  const pageCount = Math.ceil(galleryData.length / noticesPerPage);
  const startIndex = currentPage * noticesPerPage;
  const endIndex = startIndex + noticesPerPage;
  const currentNotices = galleryData.slice(startIndex, endIndex);

  return (
    <div className="flex flex-col md:flex-row md:items-center bg-gray-100 min-h-screen">
      <div className="lg:w-1/4 bg-white shadow-md">
        <AdminNavbar />
      </div>

      <div className="flex-1 p-6 md:flex-row">
        <h2 className="text-3xl font-bold mb-8 text-center">Gallery</h2>
        <Button
          type="primary"
          className="mb-6 mx-auto block px-2 py-2"
          onClick={() => setModalOpen(true)}
        >
          Add Gallery
        </Button>

        {/* Content */}
        <div className="  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {currentNotices.map((gall) => (
            <div
              key={gall._id}
              className="border border-gray-200 bg-white shadow-md rounded-lg hover:shadow-lg transition duration-200 relative hover:scale-105 cursor-pointer"
            >
              <div className="relative flex items-center justify-between mb-4 border-b-2 pb-2 border-red-400 shadow-2xl py-4 px-2">
                <div className="w-full ">
                  <h1
                    className="text-xl font-semibold text-red-600 cursor-pointer"
                    onClick={() =>
                      navigate(
                        `/nvm-admin/gallery/${encodeURIComponent(
                          gall.title,
                        ).replace(/%20/g, "_")}`,
                        {
                          state: { id: gall._id },
                        },
                      )
                    }
                  >
                    {gall.title}
                  </h1>
                </div>
                <div
                  className=" "
                  onMouseEnter={() => setOpenEdit(gall._id)}
                  onMouseLeave={() => setOpenEdit(null)}
                >
                  <button
                    className="ml-12  "
                    onClick={() =>
                      setOpenEdit(openEdit === gall._id ? null : gall._id)
                    }
                  >
                    <BsThreeDotsVertical />
                  </button>
                  {openEdit === gall._id && (
                    <div
                      className="absolute bg-white shadow-md border rounded p-2 z-50 dropdown-menu"
                      style={{
                        top: "30px",
                        right: "10px",
                      }}
                    >
                      <button
                        className="block text-left mb-2 w-full px-3 py-1 hover:bg-gray-100"
                        onClick={() => {
                          setOpenEdit(null);
                          handleEdit(gall.title, gall._id);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="block text-left text-red-600 w-full px-3 py-1 hover:bg-gray-100"
                        onClick={() => {
                          setOpenEdit(null);
                          handleDelete(gall._id);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div
                onClick={() =>
                  navigate(
                    `/nvm-admin/gallery/${encodeURIComponent(
                      gall.title,
                    ).replace(/%20/g, "_")}`,
                    {
                      state: { id: gall._id },
                    },
                  )
                }
              >
                <p className="text-gray-700  text-sm mb-2 h-auto px-5 ">
                  {gall.description}
                </p>
                <div className="h-40 ">
                  {gall.photos?.[0] && (
                    <img
                      src={`${gall.photos[0]}`}
                      alt={`${gall.title}-photo`}
                      className="w-full h-full object-cover rounded-b"
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination controls moved to the bottom of the page */}
        <div className="flex justify-center mt-8 w-full">
          <Button
            type="danger"
            size="sm"
            className={`px-4 py-2 font-bold text-lg shadow-lg rounded-md ${
              currentPage <= 0 ? "hidden" : ""
            }`}
            onClick={() => currentPage > 0 && setCurrentPage(currentPage - 1)}
            disabled={currentPage <= 0}
          >
            Previous
          </Button>

          {/* Spacing between buttons */}
          <div className="mx-4" />

          <Button
            type="danger"
            size="sm"
            className={`px-4 py-2 font-bold text-lg shadow-lg rounded-md ${
              currentPage >= pageCount - 1 ? "hidden" : ""
            }`}
            onClick={() =>
              currentPage < pageCount - 1 && setCurrentPage(currentPage + 1)
            }
            disabled={currentPage >= pageCount - 1}
          >
            Next
          </Button>
        </div>
      </div>

      <GalleryModal
        isOpen={modalOpen}
        onClose={() => handleModalClose()}
        onSubmit={handleSubmit}
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        handleFilesUploaded={handleFilesUploaded}
      />
    </div>
  );
};

export default Gallery;
